import { Component, OnInit, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { BookService } from '../book.service';
import { map } from 'rxjs/operators';
import { BookTypeList } from '../../../redux/models/book/module-config';

@Component({
  standalone: false,
  selector: 'app-book-tile',
  templateUrl: './book-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookTileComponent implements OnInit {
  @Input() type = 's';
  links$: Observable<{ code: string; page: string }[]>;
  linkTitles = {
    [BookTypeList.air]: $localize`:@@book-tile.bookTypeList:Flight`,
    [BookTypeList.hotel]: $localize`:@@book-tile.bookTypeList:Hotel`,
    [BookTypeList.car]: $localize`:@@book-tile.bookHotelLinkCar:Car`
  };

  constructor(private readonly bookService: BookService) {}

  @HostBinding() get class() {
    return 'tile-book-links tile-links tile-links-' + this.type;
  }

  ngOnInit() {
    this.links$ = this.bookService.getLoadedConfig().pipe(
      map(config =>
        config.links
          ? Object.entries(config.links)
              .filter(pair => !!pair[1])
              .map(pair => ({ code: pair[0], page: pair[1] }))
          : []
      )
    );
  }
}
